export const toSlug = str =>
  str.toLowerCase().trim().replace(/[®™]/g, "").replace(/\s+/g, "-");

export const fromSlug = str =>
  str.replace(/-/g, " ");
